/**
 * @generated SignedSource<<7ad648efe21a523fb11d7116e02353b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Card_fieldSetsForIssueSearchView$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fields: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fieldId?: string;
            readonly issueType?: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
              readonly name: string;
            } | null | undefined;
            readonly name?: string;
            readonly statusCategory?: {
              readonly statusCategoryId: string;
            };
            readonly text?: string | null | undefined;
            readonly user?: {
              readonly name: string;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_Card_fieldSetsForIssueSearchView";
};
export type main_issueNavigator_Card_fieldSetsForIssueSearchView$key = {
  readonly " $data"?: main_issueNavigator_Card_fieldSetsForIssueSearchView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Card_fieldSetsForIssueSearchView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView",
  "selections": [
    {
      "concreteType": "JiraIssueFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fields",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            {
                              "kind": "ScalarField",
                              "name": "text"
                            }
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            (v1/*: any*/),
                            {
                              "kind": "LinkedField",
                              "name": "user",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "name": "picture"
                                }
                              ]
                            }
                          ],
                          "type": "JiraSingleSelectUserPickerField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "concreteType": "JiraAvatar",
                                  "kind": "LinkedField",
                                  "name": "avatar",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "small"
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/),
                            {
                              "concreteType": "JiraStatusCategory",
                              "kind": "LinkedField",
                              "name": "statusCategory",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "statusCategoryId"
                                }
                              ]
                            }
                          ],
                          "type": "JiraStatusCategoryField"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueFieldSetConnection"
};
})();

(node as any).hash = "4b5a5fcdeceffe2ed348ebd86689df52";

export default node;
